export function FinanceEntryAmountComponent(props: { amount: number }) {
  
  const brlFormat = new Intl.NumberFormat('pt-BR', {
    style: 'currency', currency: 'BRL'
  })
  
  return <>{brlFormat.format(props.amount)}</>
}